/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./alertConfig.vue?vue&type=template&id=0fcc5abe&scoped=true"
import script from "./alertConfig.vue?vue&type=script&lang=js"
export * from "./alertConfig.vue?vue&type=script&lang=js"
import style0 from "./alertConfig.vue?vue&type=style&index=0&id=0fcc5abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcc5abe",
  null
  
)

export default component.exports